import { graphql } from 'babel-plugin-relay/macro'
import { useMutation } from 'react-relay-offline'

import type { useLinkStoreToSalesAppOrderFormMutation } from './__generated__/useLinkStoreToSalesAppOrderFormMutation.graphql'

export type LinkStoreToSalesAppOrderFormProps = {
  storeId: string
}

export const useLinkStoreToSalesAppOrderForm = () => {
  return useMutation<useLinkStoreToSalesAppOrderFormMutation>(
    graphql`
      mutation useLinkStoreToSalesAppOrderFormMutation(
        $input: LinkStoreToSalesAppOrderFormInput!
      ) {
        linkStoreToSalesAppOrderForm(input: $input) {
          payload {
            id
          }
        }
      }
    `
  )
}
